package nl.astraeus.wiki.encoding

/**
 * User: rnentjes
 * Date: 10-2-16
 * Time: 10:57
 */

interface Tokenizable {
  fun tokenize(): String
}

/**
 * read text as tokens
 * tokens are seperated by <seperator> e.g. ~
 * <seperator> is escaped by <escape> e.g. `~
 */
class Tokenizer(
  val txt: String = "",
  val seperator: Char = '-',
  val escape: Char = '>'
) {
  var index = 0

  fun done() = index >= txt.length

  fun next(): String {
    val result = StringBuilder()
    var escaped = false

    while (!done()) {
      val ch = txt[index]

      if (escaped) {
        result.append(ch)
        escaped = false
      } else {
        when (ch) {
          escape -> {
            escaped = true
          }

          seperator -> {
            index++
            return result.toString()
          }

          else -> {
            result.append(ch)
          }
        }
      }

      index++
    }

    return result.toString()
  }

  fun tokenize(vararg parts: String): String {
    val result = StringBuilder()

    for (part in parts) {
      if (result.isNotEmpty()) {
        result.append(seperator)
      }
      result.append(escape(part))
    }

    return result.toString()
  }

  override fun toString(): String {
    return "Tokenizer(index=$index, txt='$txt')"
  }

  fun escape(txt: String): String {
    val result = StringBuilder()

    for (index in txt.indices) {
      when (val ch = txt[index]) {
        escape -> {
          result.append("$escape$escape")
        }

        seperator -> {
          result.append("$escape$seperator")
        }

        else -> {
          result.append(ch)
        }
      }
    }

    return result.toString()
  }

  companion object {
    fun tokenize(vararg parts: String): String {
      val tokenizer = Tokenizer()

      return tokenizer.tokenize(*parts)
    }
  }
}
